import React from "react"
import "@stripe/stripe-js"
import StringsHelper from "../../common/stringsHelper"
import { StripeClient, AccountData } from "../../generated";
import { requiresUser } from "../../login/loginHelpers";

export const StripeKey = process.env.NODE_ENV !== "production" ? "pk_test_51HICSdBQguALEwZf1byaSxd9YtDwou4WhCVYlqFs3p0fUj1VAAXiSWZZhcR6IKEkKBCeu5asa78E9oItjezITo1200EyFVB6p5" : "pk_live_51HICSdBQguALEwZfdSRg3gNNWIq5oPcEipQbSIVIanlb3TLM9yoSYYbAse1udzURZHKp3RjrV3oBLcHqT9ZZRgnU00ohLP1wWT";
const PaymentsPage: React.FC<{ user: AccountData }> = ({ user }) => {

    const availableSmsPacks = [
        { size: 250, price: 0.1 * 250 },
        { size: 1000, price: 0.09 * 1000 },
        { size: 2000, price: 0.08 * 2000 },
        { size: 5000, price: 0.07 * 5000 }
    ]

    const onPay = async (packSize: number) => {
        const sessionId = (await new StripeClient().getSms(packSize))!;
        const stripe = window.Stripe!(StripeKey);
        stripe.redirectToCheckout({ sessionId });
    }

    return (
        <div className="container-lg" style={{ paddingTop: "5%" }} >
            <h1 className="text-center display-4 mb-4">Acquista il tuo pacchetto SMS!</h1>
            <div className="row">
                {availableSmsPacks.map(pack => {
                    return <div className="col-12 col-md-4 d-flex justify-content-center">
                        <div className="card text-center" key={pack.size} style={{ maxWidth: 400 }}>
                            <div className="card-header">
                                <div className="badge bg-info fs-2" ><i className="fas fa-sms fa-lg me-2" /> {pack.size} SMS</div>
                            </div>
                            <div className="card-body">
                                <div className="fw-bold" style={{ fontSize: "1rem" }}>TOTALE</div>
                                <small>IVA esclusa</small>
                                <div className="fw-bold text-success" style={{ fontSize: "3.5rem" }}>€ {StringsHelper.toDecimalString(pack.price)}</div>
                                <div className="fw-bold text-success">{StringsHelper.toDecimalString(pack.price / pack.size)}€/sms</div>
                                <div className="text-secondary">{StringsHelper.toDecimalString(pack.price + (pack.price * 0.22))}€ Iva compresa</div>
                                <button className="btn btn-success w-100" style={{ fontSize: "1.3rem" }} onClick={() => onPay(pack.size)}>
                                    <i className="fas fa-shopping-cart" />  Acquista con carta di credito
                                </button>
                            </div>
                        </div>
                    </div>
                })}
            </div>
        </div>)
}

export default requiresUser(PaymentsPage);